export default {
  "name": "NCMultiLangText",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCMultiLangText",
  "label": "多语文本",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "className": {
        "title": "className",
        "description": "样式",
        "type": "string"
      },
      "fieldid": {
        "title": "自动化Id",
        "description": "自动化Id",
        "type": "string"
      },
      "autoFocus": {
        "title": "自动聚焦",
        "description": "自动聚焦",
        "type": "boolean"
      },
      "maxLength": {
        "title": "最大长度",
        "description": "最大长度",
        "type": "number"
      },
      "renderInTable": {
        "title": "renderInTable",
        "description": "renderInTable",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}